<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     充值记录清单
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    :visible.sync="dialogShow"
    width="900px"
    :modal-append-to-body="false">
    <div slot="title">
      <span class="font-lg">充值清单共计 <b class="text-primary">{{ list.length }}</b> 个接入点</span>
    </div>
    <el-table v-loading="loading" :data="list" tooltip-effect="dark" style="width: 100%" max-height="500">
      <el-table-column type="index" width="50" />
      <el-table-column property="simid" label="接入点编号" min-width="150" />
      <el-table-column align="center" label="充值前有效期" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.old_expire">{{ scope.row.old_expire | parseTime('{y}/{m}/{d}') }}</span>
          <span v-else class="text-primary">{{ '预充' + scope.row.old_precharge_month / 12 + '年' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="充值后有效期" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.old_expire">{{ scope.row.new_expire | parseTime('{y}/{m}/{d}') }}</span>
          <span v-else class="text-primary">{{ '预充' + scope.row.new_precharge_month / 12 + '年' }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { apOrderGetApi } from '@/api/ap/apOrderApi'
export default {
  name: 'ApOrderDetail',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderid: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      apOrderGetApi({ orderid: this.orderid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
